export default class Margin{
    constructor(data) {
            this.margin = `${data.top}px ${data.right}px ${data.bottom}px ${data.left}px`
    }
}